module.exports = __webpack_public_path__ + "img/map.b5eef698.svg";